import type { JSX } from 'react'

import { TextAligning, TextBox } from 'atoms/TextBox'
import { TextBoxMaxLine2FontSm } from 'atoms/TextBox/Templates'
import { Colors, TextBoxTypes } from 'atoms/TextBox/TextBox.h'
import { UpgradeCurrentPackageSC } from './InfoUpgradeCurrentPackage.styled'

export interface IInfoUpgradeCurrentPackageProps {
  title: string
  description: string
  smallPlayer?: boolean
}

export const InfoUpgradeCurrentPackage = ({
  title,
  description,
  smallPlayer,
}: IInfoUpgradeCurrentPackageProps): JSX.Element => {
  const font = smallPlayer ? TextBoxTypes.FontLgBold : TextBoxTypes.FontXlBold
  return (
    <UpgradeCurrentPackageSC smallPlayer={smallPlayer}>
      <TextBox
        font={font}
        title={title}
        alignment={TextAligning.Center}
        maxLines={2}
      />

      <TextBoxMaxLine2FontSm
        title={description}
        alignment={TextAligning.Center}
        color={Colors.TEXT_ICON_SECONDARY}
      />
    </UpgradeCurrentPackageSC>
  )
}
